import script from "./SecurityDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./SecurityDashboard.vue?vue&type=script&setup=true&lang=js"

import "./SecurityDashboard.vue?vue&type=style&index=0&id=2ad0e33f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ad0e33f"]])

export default __exports__